import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
import(/* webpackMode: "eager" */ "/app/src/app/loading.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/Features/SalesProposal/SalesProposal.tsx")